import { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import { DeleteIcon, EditIcon } from 'pages/ServicesCategory/components/AddVendorModal/icons';
import { useDispatch } from 'react-redux';
import {
  deletePartnerDraftsAsRecommendations,
  setVendorDraftEditModeId,
} from 'store/actions/partners';
import { deleteVendorDraftById } from 'api/partners';
import { showErrorMessage, showSuccessMessage } from 'helpers';

type DraftActionsPropsType = {
  draftId: number;
};

const DraftActions = (props: DraftActionsPropsType) => {
  const { draftId } = props;
  const dispatch = useDispatch();
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const menuRef = useRef<any>(null);
  const [deleting, setDeleting] = useState<boolean>(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      let targetId = '';
      if (event.target) {
        targetId = (event.target as any).id;
      }

      if (targetId === 'vendorDraftMenuIcon' || targetId === 'vendorDraftMenu') return;

      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getHamburgerDots = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.hbIcon}
      id="vendorDraftMenuIcon"
    >
      <circle cx="5" cy="12" r="2" />
      <circle cx="12" cy="12" r="2" />
      <circle cx="19" cy="12" r="2" />
    </svg>
  );

  const handleEditClick = (e) => {
    e.stopPropagation();
    setShowMenu(false);
    dispatch(setVendorDraftEditModeId(draftId));
  };

  const handleDeleteClick = async (e) => {
    e.stopPropagation();
    setShowMenu(false);
    setDeleting(true);
    try {
      const response = await deleteVendorDraftById(draftId);
      if (response.status === 200) {
        dispatch(deletePartnerDraftsAsRecommendations({ id: draftId }));
        showSuccessMessage('Draft deleted');
      }
    } catch (e) {
      showErrorMessage('Unable to delete draft');
    }
    setDeleting(false);
  };

  return (
    <div
      className={styles.draftActions}
      onClick={() => {
        if (deleting) return;
        setShowMenu((prev) => !prev);
      }}
      id="vendorDraftMenu"
    >
      {getHamburgerDots()}
      {showMenu && (
        <div className={styles.menu} ref={menuRef}>
          <div className={styles.item} onClick={handleEditClick}>
            <span className={styles.icon}>
              <EditIcon />
            </span>
            <div className={styles.label}>Edit</div>
          </div>
          <div className={styles.item} onClick={handleDeleteClick}>
            <span className={styles.icon}>
              <DeleteIcon />
            </span>
            <div className={styles.label}>Delete</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DraftActions;
